import { azul, brand, neutro, semantic } from 'styles/tokens'

/**
 * Cores legadas, agora apontando para os tokens da Corretto. Os nomes "azul*"
 * vem de antes do tema cinza e voltaram a ser azuis. Codigo novo deve usar o
 * tema (`theme.palette`) ou `styles/tokens` direto.
 */
export const Colors = {
  azul: brand.azul,
  azulSecundario: azul[600],
  azulTerciario: azul[700],
  azulQuaternario: azul[900],
  fonte: brand.grafite,
  cinza: neutro[300],
  cinzaSegundario: neutro[400],
  vermelhoError: semantic.errorDark
}
